import { useContext, useMemo, useState } from "react";
import ConfirmDialog from "../components/shared/ConfirmDialog";
import { DROP_BOOKING } from "../gql/bookingapi";
import { useSelector } from "react-redux";
import { withApollo } from "react-apollo";
import { PaginationContext } from "../components/shared/pagination/PaginationContext";
import { getPreviousHalfHourLabel } from "../utils/helpers/dropBooking";

const DROP_TYPE_CONFIG = {
  cancel: {
    title: "Cancel booking",
    content: "Are you sure to cancel bookings?",
    showReasonDD: true,
    reasonDropdowmLabel: "Please add reason for cancel booking",
    secondaryContent: () => "",
    disableBooking: (reasonValue) => !reasonValue,
  },
  end: {
    title: "End booking now",
    content: "Do you want to end this booking earlier than planned?",
    showReasonDD: false,
    reasonDropdowmLabel: "",
    secondaryContent: (previousHalfHour) => (
      <div>{`The equipment will be available from ${previousHalfHour} for other users again.`}</div>
    ),
    disableBooking: () => false,
  },
  multipleEnd: {
    title: "End booking now",
    content: "This booking includes multiple equipment and/or time slots",
    showReasonDD: false,
    reasonDropdowmLabel: "",
    secondaryContent: (previousHalfHour) => (
      <>
        <div>Do you want to end this booking for all of them?</div>
        <div>{`All equipment will be available from ${previousHalfHour} for other users again.`}</div>
      </>
    ),
    disableBooking: () => false,
  },
  // here calculateRequiredSlots computeSlotDiff for future reference
  recurringEnd: {
    title: "End booking now for current occurrence",
    content: "Do you want to end this booking earlier than planned?",
    showReasonDD: false,
    reasonDropdowmLabel: "",
    secondaryContent: (previousHalfHour) => (
      <div>{`The equipment will be available from ${previousHalfHour} for other users again.`}</div>
    ),
    disableBooking: () => false,
  },
  multipleRecurringEnd: {
    title: "End booking now for current occurrence",
    content: "This booking includes multiple equipment",
    showReasonDD: false,
    reasonDropdowmLabel: "",
    secondaryContent: (previousHalfHour) => (
      <>
        <div> Do you want to end this booking for all of them?</div>
        <div>{`All equipment will be available from ${previousHalfHour} for other users again.`}</div>
      </>
    ),
    disableBooking: () => false,
  },
};

const DROP_TYPES = {
  cancel: "CANCEL_REQUEST",
  end: "END_REQUEST",
};

const handleCancelFactory = async ({
  client,
  user,
  reasonValue,
  force,
  item,
  setStatus,
  dispatchAction,
  triggerFetch,
  dropType,
}) => {
  try {
    setStatus(true);
    triggerFetch && triggerFetch(false);
    const DROP_TYPE = DROP_TYPES[dropType] || DROP_TYPES.cancel;

    await client.mutate({
      mutation: DROP_BOOKING,
      variables: {
        createdBy: user.user,
        remark: reasonValue || (DROP_TYPE === DROP_TYPES.end ? "End booking" : "Cancel booking"),
        force: force,
        bookingId: item,
        DROP_TYPE,
      },
    });
  } catch (e) {
    setStatus(false);
    dispatchAction({
      type: "clearAll",
    });
  } finally {
    triggerFetch && triggerFetch(true);
  }
};

const DeleteBooking = ({
  client,
  dropType,
  setIsDropBooking,
  setIsDialogOpen,
  isDialogOpen = false,
  force = false,
  item,
  status,
  setStatus,
  triggerFetch = null,
}) => {
  const [reasonValue, setReasonValue] = useState(null);
  const user = useSelector((store) => store.user);
  const { dispatchAction } = useContext(PaginationContext);

  const handlerOnDropBooking = async (dropType) => {
    dispatchAction({
      type: "fetching",
      payload: true,
    });
    handleCancelFactory({
      client,
      user,
      reasonValue,
      force,
      item,
      setStatus,
      dispatchAction,
      triggerFetch,
      dropType,
    });
    setReasonValue("");
  };

  const onReasonChanged = (reason) => {
    setReasonValue(reason);
  };

  const handleOnclose = () => {
    setIsDropBooking(false);
    setIsDialogOpen(false);
    setReasonValue("");
    return true;
  };
  const handlerOnCancelDeleteBooking = () => {
    setIsDropBooking(false);
    setIsDialogOpen(false);
    setReasonValue("");
  };
  const previousHalfHour = useMemo(() => getPreviousHalfHourLabel(user.timezone), [user.timezone]);

  const dialogConfig = useMemo(() => {
    const config = DROP_TYPE_CONFIG[dropType] || DROP_TYPE_CONFIG.cancel;

    return {
      title: config.title,
      content: config.content,
      showReasonDD: config.showReasonDD,
      reasonDropdowmLabel: config.reasonDropdowmLabel,
      secondaryContent: config.secondaryContent(previousHalfHour),
      disableBooking: config.disableBooking(reasonValue),
    };
  }, [dropType, previousHalfHour, reasonValue]);
  return (
    <ConfirmDialog
      approveText="Confirm"
      approveColor="primary"
      approveVariant="contained"
      cancelText="Cancel"
      cancelVariant="outlined"
      cancelColor="primary"
      onApprove={() => handlerOnDropBooking(dropType || null)}
      title={dialogConfig.title}
      content={dialogConfig.content}
      secondaryContent={dialogConfig.secondaryContent}
      showReasonDD={dialogConfig.showReasonDD}
      reasonValue={reasonValue}
      onReasonChanged={onReasonChanged}
      disableBooking={dialogConfig.disableBooking}
      close={handleOnclose}
      open={isDialogOpen}
      onCancel={handlerOnCancelDeleteBooking}
      fullWidth={false}
      maxWidth="sm"
      reasonDropdowmLabel={dialogConfig.reasonDropdowmLabel}
      loading={status}
    />
  );
};

export default withApollo(DeleteBooking);
